import { getAPIClient } from "./http";

export const api = getAPIClient()
